import { use } from "i18next";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

const ToolTipChild = forwardRef((props, ref) => {
  const [isMounted, setMounted] = useState(false);
  const [isHover, setHover] = useState(false);
  const div = useRef();
  const [left, setLeft] = useState(0);
  const [top, setTop] = useState(0);
  

  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (isMounted) {
      const parent = props.group?.current?.getBox();
      const box = div.current.getBoundingClientRect();
      if (box) {
        setLeft(parent.x - box.x + box.width + Number(props.left || 0));
        setTop(box.top - parent.top - box.height + Number(props.top || 0));
      }
    }
  }, [isMounted, props, props.group, div, props.children]);
  useEffect(() => {
    if (isMounted) {
      if (props?.group?.current) {
        props.group.current.reload();
      }
    }
  }, [isHover]);
  useImperativeHandle(ref, () => ({
    getTitle() {
      return isHover ? (
        <div
          style={{
            zIndex: props?.zIndex,
            left: left,
            // right: props?.right,
            top: top,
            // bottom: props?.bottom,
            position: "absolute",
            ...props.style,
          }}
          className={props.className}
        >
          {props.title}
        </div>
      ) : (
        <></>
      );
    },
  }));
  return (
    <div
      ref={div}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {props.children}
    </div>
  );
});

export default ToolTipChild;
